export const checklistDataForm = {
  mainTitle: 'Is Golang the right choice for your project?',
  description: 'Download the checklist and find out!',
  thankYouTitle: 'Thank you!',
  thankYouNote: 'Check your email box and discover what we have prepared for you!',
};
